<div class="container">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode() }">
    <form [formGroup]="updateForm">
      <div class="row">
        <div class="col">
          <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="this.updateForm.controls['from_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="this.updateForm.controls['to_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-custom-dropdown
          [placeholder]="'ALL'"
            [label]="'Segment:'"
            [items]="segmentOptions"
            [controlname]="this.updateForm.controls['segment']"
          ></app-custom-dropdown>
        </div>
        <div class="col">
          <app-custom-dropdown
          [placeholder]="'ALL'"
            [label]="'Condition:'"
            [items]="condition"
            [controlname]="this.updateForm.controls['condition']"
          ></app-custom-dropdown>
        </div>
        <div class="col">
          <app-custom-input
            placeholder="Ship Name"
            label="Ship Name"
            [controlname]="this.updateForm.controls['shipName']"
          ></app-custom-input>
        </div>
        <div class="filterBtn">
          <button
            class="btn btn-light hover-button apply"
            (click)="clearClick()"
          >
            <mat-icon>clear_all</mat-icon>
            <span class="name">Clear Filter</span>
          </button>
        </div>
        <div class="filterBtn">
          <button
            class="btn btn-light hover-button apply"
            (click)="filterClick()"
          >
            <mat-icon class="filterIcon">filter_list</mat-icon>
            <span class="name">Apply Filter</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <br />
  <div class="table-container scroll-bar">
    <table
      class="mat-elevation-z8"
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="fixed-header">
        <tr>
          <th rowspan="2">S.No</th>
          <th mat-sort-header="ship"  class="th-text-center3" rowspan="2">Ship Name</th>
          <th rowspan="2">Customer</th>
          <th rowspan="2">Segment</th>
          <th class="th-text-center2" mat-sort-header="merakiPic" rowspan="3">Meraki Pic</th>
          <th colspan="2">Ports</th>
          <th colspan="2">ATA(LT)</th>
          <th rowspan="2">Condition</th>
          <th rowspan="2">CP Speed</th>
          <th rowspan="2">Time Updated(UTC)</th>
        </tr>
        <tr>
          <th  class="th-text-center" mat-sort-header="pFrom"><span>From</span></th>
          <th  class="th-text-center1" mat-sort-header="pTo"><span>To</span></th>
          <th mat-sort-header="etaDate"><span>Date(DDMM)</span></th>
          <th><span>Time(HHMM)</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td>{{ rowIndex + 1 }}</td>
          <td>{{ element.ship }}</td>
          <td>{{ element.customername }}</td>
          <td><span [ngStyle]="getDynamicSegmentStyle(element.segment)">
              {{ element.segment }}
            </span></td>
          <td>{{ element.merakiPic }}</td>
          <td>{{ element.pFrom }}</td>
          <td>{{ element.pTo }}</td>
          <td>{{ formatDate(element.etaDate) }}</td>
          <td>{{ formatTime(element.etaDate) }}</td>
          <td>{{ element.voyageType }}</td>
          <td>{{ element.cpOrderedSpeed }}</td>
          <td>{{ convertToUTC(element.updatedAt) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="tableData.length"
    [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  <div class="text-right">
    <button class="btn btn-light hover-button apply" (click)="exportClick()">
      <mat-icon>download</mat-icon>
      <span class="name"> Export</span>
    </button>
  </div>
</div>
